import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

export default function Services() {
  const { copy } = useLanguage();
  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid="services-page">
      <Seo title={copy.seo.services.title} description={copy.seo.services.desc} />
      <div className="max-w-6xl mx-auto px-5">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.22em] text-clay font-semibold mb-3">{copy.services.eyebrow}</p>
          <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight">{copy.services.title}</h1>
          <p className="mt-4 text-muted max-w-xl">{copy.services.sub}</p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {copy.services.items.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.1}>
              <div
                data-testid={`service-card-${s.id}`}
                className={`relative h-full rounded-3xl border p-7 flex flex-col transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl ${
                  s.id === "mes" ? "bg-pine text-linen border-pine" : "bg-white border-border hover:border-pine/30"
                }`}
              >
                {s.id === "mes" && (
                  <span className="absolute -top-3 left-6 rounded-full bg-clay px-3 py-1 text-[11px] font-mono font-semibold uppercase tracking-widest text-white">
                    {copy.services.popular}
                  </span>
                )}
                <p className={`text-xs font-mono uppercase tracking-widest ${s.id === "mes" ? "text-gold" : "text-clay"}`}>{s.tag}</p>
                <h2 className={`mt-2 font-serif font-semibold text-2xl ${s.id === "mes" ? "text-linen" : "text-ink"}`}>{s.title}</h2>
                <div className="mt-1 flex items-baseline gap-3">
                  <p className={`font-serif text-4xl font-semibold ${s.id === "mes" ? "text-gold" : "text-pine"}`}>{s.price}</p>
                  <p className={`text-sm ${s.id === "mes" ? "text-linen/70" : "text-muted"}`}>{s.duration}</p>
                </div>
                <p className={`mt-4 text-sm leading-relaxed ${s.id === "mes" ? "text-linen/85" : "text-muted"}`}>{s.desc}</p>
                <ul className="mt-5 space-y-2.5 flex-1">
                  {s.features.map((f, j) => (
                    <li key={j} className={`flex gap-2.5 text-sm ${s.id === "mes" ? "text-linen/85" : "text-ink/75"}`}>
                      <Check size={15} className={`mt-0.5 shrink-0 ${s.id === "mes" ? "text-gold" : "text-clay"}`} /> {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/contacto?servicio=${s.id}`}
                  data-testid={`service-cta-${s.id}`}
                  className={`mt-7 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-colors duration-300 ${
                    s.id === "mes" ? "bg-clay text-white hover:bg-clay-dark" : "border border-pine text-pine hover:bg-pine hover:text-linen"
                  }`}
                >
                  {copy.services.cta} <ArrowRight size={15} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-12 rounded-3xl border border-gold/50 bg-gold-light/60 px-7 py-6" data-testid="services-note">
            <p className="text-sm sm:text-base text-ink/80 leading-relaxed font-medium">{copy.services.note}</p>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
